/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from "react";
import { request } from "../../../../utils/request";

export const useData = (tipoNotaDebito, contacto) => {
	const [comprobantes, setComprobantes] = useState([]);
	const [facturas, setFacturas] = useState([]);

	const getFacturasForDropdown = useCallback(async () => {
		if (tipoNotaDebito === "compra") {
			await request(`compras-for-dropdown?contacto=${contacto}`).then((res) => {
				setFacturas(res.data);
			});
			return;
		}
		await request(`facturas-for-dropdown?contacto=${contacto}`).then((res) => {
			setFacturas(res.data);
		});
	}, [contacto]);

	const getRazonesForDropdown = useCallback(async () => {
		let razones = [];
		await request("razones-for-dropdown?modulo=nota-debito").then((res) => {
			razones = res.data;
		});

		return razones;
	}, [tipoNotaDebito]);

	const getComprobantesForDropdown = useCallback(async () => {
		request("notas-debito-comprobantes").then((res) => {
			setComprobantes(res.data);
		});
	}, [tipoNotaDebito]);

	useEffect(() => {
		if (!tipoNotaDebito) return;
		getComprobantesForDropdown();
	}, [tipoNotaDebito]);

    useEffect(() => {
        if (!contacto) return;
        getFacturasForDropdown();
    }, [contacto]);

	return useMemo(
		() => ({ comprobantes, facturas, getRazonesForDropdown }),
		[comprobantes, facturas, getRazonesForDropdown]
	);
};
